import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
import { stringifyFilters } from "security-app/components/common/Filters/stringifyFilters";
import fetch from "logic/rest/FetchProvider";
export const fetchInvestigations = async (page, perPage, query = null, orderBy = void 0, direction = void 0, filters = {}, archived = false, userTimezone = null) => {
  const params = [`page=${page}`, `per_page=${perPage}`, `archived=${archived}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (filters && Object.keys(filters).length > 0) {
    params.push(`filters=${encodeURI(stringifyFilters(filters))}`);
    params.push(`user_timezone=${encodeURI(userTimezone)}`);
  }
  if (orderBy) {
    params.push(`sort=${orderBy}`);
  }
  if (direction) {
    params.push(`direction=${direction}`);
  }
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.index(params.join("&")).url));
};
export const fetchInvestigationsFilterOptions = async ({
  fields,
  archived
}) => {
  const payload = {
    fields,
    archived
  };
  return fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.filters().url), payload);
};
const investigationToUpdatePayload = (investigation) => ({
  id: investigation.id,
  name: investigation.name,
  assigned_to: investigation.assigned_to,
  priority: investigation.priority,
  status: investigation.status,
  archived: investigation.archived
});
export const updateInvestigations = async ({ investigations }) => {
  const payload = {
    requests: investigations.map(investigationToUpdatePayload)
  };
  return fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.update().url), payload);
};
export const getInvestigationsDashboardView = async (viewId) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.Dashboards.viewConfig(viewId).url));
export const getInvestigationsDashboardSearch = async (searchId) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.Dashboards.searchJob(searchId).url));
export const getInvestigationsDashboardSearchResults = async ({
  searchId,
  payload
}) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.Dashboards.searchJobResults(searchId).url), payload);
export const getInvestigationDetails = async (invId, includeLogsAndEvents = false) => fetch(
  "GET",
  qualifyUrl(
    EnterpriseApiRoutes.SecurityApp.Investigations.singleInvestigation(
      invId,
      `include_logs_and_events=${includeLogsAndEvents}`
    ).url
  )
);
export const fetchPaginatedInvestigationSecurityEvents = async (invId, page, perPage) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  return fetch(
    "GET",
    qualifyUrl(
      EnterpriseApiRoutes.SecurityApp.Investigations.paginatedInvestigationSecurityEvents(invId, params.join("&")).url
    )
  );
};
export const fetchPaginatedInvestigationLogs = async (invId, page, perPage) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  return fetch(
    "GET",
    qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.paginatedInvestigationLogs(invId, params.join("&")).url)
  );
};
export const archiveInvestigation = async ({ invId, archive }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.archive(invId, archive).url));
export const bulkArchiveInvestigation = async ({ payload }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.bulkArchive().url), payload);
export const deleteInvestigation = async ({ invId }) => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.singleInvestigation(invId).url));
export const bulkDeleteInvestigations = async ({ payload }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.bulkDelete().url), payload);
export const addEvidence = async ({ invId, payload }) => fetch(
  "PUT",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.addEvidenceToInvestigation(invId).url),
  payload
);
export const bulkAddEvidence = async ({ payload }) => fetch(
  "PUT",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.bulkAddEvidenceToInvestigation().url),
  payload
);
export const removeEvidence = async ({ invId, payload }) => fetch(
  "PUT",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.removeEvidenceFromInvestigation(invId).url),
  payload
);
export const addNote = async ({ invId, note }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.addNoteToInvestigation(invId).url), note);
export const editNote = async ({ invId, noteId, note }) => fetch(
  "PUT",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.editInvestigationNote(invId, noteId).url),
  note
);
export const deleteNote = async ({ invId, noteId }) => fetch(
  "DELETE",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.deleteInvestigationNote(invId, noteId).url)
);
export const newInvestigation = async ({ payload }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.new().url), payload);
export const fetchPriorities = async () => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.priorities.index().url));
export const fetchStatuses = async () => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.statuses.index().url));
export const fetchUsers = async () => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.fetchUsers().url));
export const fetchTeams = async () => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.fetchTeams().url));
export const fetchInvestigationsConfig = async () => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.fetchConfig().url));
export const enableNotifications = async ({ enabled }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.enableNotifications(enabled).url));
export const addPriority = async ({ priority }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.priorities.add().url), priority);
export const reprioritizePriorities = async ({ payload }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.priorities.reprioritize().url), payload);
export const updatePriority = async ({ priorityId, priority }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.priorities.update(priorityId).url), priority);
export const deletePriority = async ({ priorityId }) => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.priorities.delete(priorityId).url));
export const addStatus = async ({ status }) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.statuses.add().url), status);
export const updateStatus = async ({ statusId, status }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.statuses.update(statusId).url), status);
export const deleteStatus = async ({ statusId }) => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.statuses.delete(statusId).url));
export const setDefaultPriority = async ({ priorityId }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.priorities.setDefault(priorityId).url));
export const removeDefaultPriority = async () => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.priorities.removeDefault().url));
export const setDefaultStatus = async ({ statusId }) => fetch("PUT", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.statuses.setDefault(statusId).url));
export const removeDefaultStatus = async () => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.statuses.removeDefault().url));
export const fetchInvestigationProcedures = async (invId, params) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.Procedures.index(invId, params).url));
export const fetchProcedureTitles = async (invId, procedureId, params) => fetch(
  "GET",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.Investigations.Procedures.titles(invId, procedureId, params).url)
);
export const fetchProcedureStepEvents = async (invId, procedureId, stepId, params) => fetch(
  "GET",
  qualifyUrl(
    EnterpriseApiRoutes.SecurityApp.Investigations.Procedures.steps.events(invId, procedureId, stepId, params).url
  )
);
